<template>
    <button
        type="button"
        class="chat-summary-card"
        :class="{ 'chat-summary-card--active': active }"
        @click="$emit('select', chat)"
    >
        <CBadge
            v-if="chat.unread_count"
            color="danger"
            class="chat-summary-card__unread-badge"
        >
            {{ chat.unread_count }}
        </CBadge>
        <div class="chat-summary-card__head">
            <div class="chat-summary-card__name">
                <template v-if="showCustomer">
                    {{ chat.customer_name || 'Без имени' }}
                    <span v-if="chat.phone">({{ chat.phone }})</span>
                </template>
                <template v-else>
                    {{ chat.title }}
                </template>
            </div>
        </div>
        <div v-if="showCustomer" class="chat-summary-card__thread">{{ chat.title }}</div>
        <div class="chat-summary-card__message">
            {{ chat.last_message || 'Без сообщений' }}
        </div>
        <div class="chat-summary-card__meta">
            <CBadge :color="statusColor" class="mr-2">{{ statusLabel }}</CBadge>
            <span>{{ formatDate(chat.last_message_at) }}</span>
        </div>
    </button>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'ChatSummaryCard',
        props: {
            chat: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            },
            showCustomer: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            statusLabel() {
                return this.chat.status === 'closed' ? 'Закрыт' : 'В работе';
            },
            statusColor() {
                return this.chat.status === 'closed' ? 'secondary' : 'warning';
            }
        },
        methods: {
            formatDate(value) {
                if (!value) {
                    return '';
                }
                return moment(value).format('DD.MM HH:mm');
            }
        }
    };
</script>

<style scoped>
.chat-summary-card {
    position: relative;
    width: 184px;
    min-height: 164px;
    border: 1px solid #e4e7ea;
    border-radius: 8px;
    padding: 10px;
    background: #ffffff;
    text-align: left;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-shrink: 0;
}

.chat-summary-card:hover {
    background: #f8f9fb;
}

.chat-summary-card--active {
    border-color: #321fdb;
    background: #f8f9fb;
}

.chat-summary-card__head,
.chat-summary-card__meta {
    display: flex;
    align-items: center;
    gap: 8px;
}

.chat-summary-card__head {
    padding-right: 28px;
}

.chat-summary-card__meta {
    justify-content: space-between;
}

.chat-summary-card__name {
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    max-height: 30px;
    overflow: hidden;
}

.chat-summary-card__thread {
    margin-top: 6px;
    font-size: 11px;
    color: #6c757d;
}

.chat-summary-card__message {
    margin-top: 6px;
    font-size: 12px;
    line-height: 16px;
    color: #4f5d73;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    flex: 1;
    word-break: break-word;
}

.chat-summary-card__meta {
    margin-top: auto;
    padding-top: 8px;
    font-size: 11px;
    color: #8a93a2;
}

.chat-summary-card__unread-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0 7px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    border-radius: 999px;
}
</style>

<style>
.chat-summary-cards {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.chat-summary-cards--horizontal {
    flex-wrap: nowrap;
    overflow-x: auto;
    margin-bottom: 12px;
}
</style>
